module.exports = __webpack_public_path__ + "media/images/lb/284-22655b1837e88c8ccc6a00c3ebd756d9.svg";